module.exports = __webpack_public_path__ + "img/pProject-banner3.36ce6c9c.jpg";